"use client";

import type { CreditBalanceResponse } from "../hooks/use-subscription";

interface Props {
  credits: CreditBalanceResponse;
}

export function CreditBar({ credits }: Props) {
  const { balance, total_allocation, next_cycle_allocation } = credits;
  const used = Math.max(total_allocation - balance, 0);
  const percentage =
    total_allocation > 0 ? (used / total_allocation) * 100 : 0;
  const showRenewalHint =
    next_cycle_allocation > total_allocation && total_allocation > 0;

  return (
    <div className="rounded-lg border border-border bg-surface-elevated p-5">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-medium text-heading">Credits</h3>
        <span className="text-sm text-muted-foreground">
          {balance.toLocaleString()} / {total_allocation.toLocaleString()}{" "}
          remaining
        </span>
      </div>
      <div className="h-2 rounded-full bg-white/5 overflow-hidden">
        <div
          className={`h-full rounded-full transition-all ${
            percentage > 90
              ? "bg-red-500"
              : percentage > 70
                ? "bg-amber-500"
                : "bg-primary"
          }`}
          style={{ width: `${Math.min(percentage, 100)}%` }}
        />
      </div>
      <p className="text-xs text-muted-foreground mt-2">
        {used.toLocaleString()} credits used this billing cycle
      </p>
      {showRenewalHint && (
        <p className="text-xs text-muted-foreground mt-1">
          Renews at {next_cycle_allocation.toLocaleString()} credits
        </p>
      )}
    </div>
  );
}
